import React, { useState } from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import _ from 'lodash'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import LayoutInplay from '../components/layout-inplay'
import FixtureCard from '../components/FixtureCard'
import Icons from '../components/Icons'

const WrapperContainer = styled.div`
  padding: 0 20px 10px 20px;

  @media (max-width: 768px) {
    padding: 0 0 10px 0;
  }
`
const InplayAppBar = styled(AppBar)`
  background: ${props => props.theme.palette.background.paper};
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0) !important;
`
const InplayTabs = styled(Tabs)`
  background: ${props => props.theme.palette.background.paper};
`
const CompetitionHeader = styled.div`
  padding: 10px 20px;
  font-size: 0.889em;
  font-weight: 600;
  text-transform: uppercase;
  color: ${props => props.theme.palette.text.secondary};
`

// Add an "inplay" field to the posts.json
// GraphQL query is filtering by "inplay"

const InPlayPage = ({ data }) => {
  // Local state
  // value is the selected sport (via tabs change)
  const [value, setValue] = useState(0)

  // the fixtures
  const { edges } = data.allPostsJson

  // Create a unique list of sports
  const sports = _.uniq(Object.keys(edges).map(key => edges[key].node.sport))

  // Create a unique list of competitions for the selected sport 'value'
  // via the tabs component
  const competitions = _.uniq(
    Object.keys(edges).reduce((result, key) => {
      if (edges[key].node.sport === sports[value]) {
        result.push(edges[key].node.competition)
      }
      return result
    }, [])
  )

  // handleChange as per MUI docs example
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const sportHeader = sports.map(sport => (
    <CompetitionHeader key={sport}>{sport}</CompetitionHeader>
  ))

  if (!sports.length) {
    return (
      <LayoutInplay>
        <div>No Inplay markets at this time</div>
      </LayoutInplay>
    )
  }

  return (
    <LayoutInplay>
      <InplayAppBar position="static" color="default">
        <InplayTabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          indicatorColor="primary"
          textColor="primary"
        >
          {sports.map((sport, key) => (
            <Tab
              key={key}
              label={sport}
              icon={
                <Icons
                  icon={sport}
                  style={{
                    fontSize: 24,
                    marginBottom: '6px',
                  }}
                />
              }
            />
          ))}
        </InplayTabs>
      </InplayAppBar>
      <WrapperContainer>
        {competitions.map((key, comp) => (
          <div key={key}>
            <CompetitionHeader>{sports[value]}</CompetitionHeader>
            <CompetitionHeader>{competitions[comp]}</CompetitionHeader>
            {edges.map(({ node }) => {
              if (
                node.sport === sports[value] &&
                competitions[comp] === node.competition
              ) {
                return <FixtureCard key={node.id} fixture={node} inplay />
              }
              return null
            })}
          </div>
        ))}
      </WrapperContainer>
    </LayoutInplay>
  )
}

InPlayPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export const inPlayQuery = graphql`
  query InPlayQuery {
    allPostsJson(filter: { status: { eq: "inplay" } }) {
      edges {
        node {
          id
          slug
          sport
          competition
          date
          start
          status
          marketCount
          team1title
          team2title
          gametime
          gameperiod
          gamescore
          markets {
            title
            outcomes {
              name
              odds
            }
          }
        }
      }
    }
  }
`
export default InPlayPage
